import { FC, FormEvent, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { TextField } from "@radix-ui/themes";

import { Button } from "@/components/button";

interface CollectionsSearchFormProps {
  initialQuery?: string;
  initialSpaceAccountId?: string;
  onSearch: (params: { query: string; spaceAccountId: string }) => void;
}

export const CollectionsSearchForm: FC<CollectionsSearchFormProps> = ({
  initialQuery = "",
  initialSpaceAccountId = "",
  onSearch,
}) => {
  const [queryValue, setQueryValue] = useState<string>(initialQuery);
  const [spaceAccountIdValue, setSpaceAccountIdValue] = useState<string>(initialSpaceAccountId);

  useEffect(() => {
    setQueryValue(initialQuery);
  }, [initialQuery]);

  useEffect(() => {
    setSpaceAccountIdValue(initialSpaceAccountId);
  }, [initialSpaceAccountId]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch({ query: queryValue.trim(), spaceAccountId: spaceAccountIdValue.trim() });
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <TextFieldContainer
        placeholder="Space Account ID (optional)"
        value={spaceAccountIdValue}
        onChange={event => setSpaceAccountIdValue(event.currentTarget.value)}
        maxLength={36}
        aria-label="Filter by Space Account ID"
      />
      <TextFieldContainer
        placeholder="Search collections by title, description, or UUID"
        value={queryValue}
        onChange={event => setQueryValue(event.currentTarget.value)}
        maxLength={120}
        aria-label="Search Collections"
      />
      <Button type="submit">Search</Button>
    </FormContainer>
  );
};

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-start;
  width: 100%;
  max-width: 480px;
  margin-bottom: 1.5rem;
`;

const TextFieldContainer = styled(TextField.Root)`
  width: 100%;
`;
